import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FirebaseService } from "src/app/core/firebase/firebase.service";
import { AppService } from "src/app/core/app/app.service";
import { AuthService } from "src/app/core";
import { Venue } from "src/app/core/venue/venue.model";

@Component({
  selector: "ll-welcome-user",
  templateUrl: "./welcome-user.component.html",
  styleUrls: ["./welcome-user.component.scss"]
})
export class WelcomeUserComponent implements OnInit {
  constructor(public app: AppService, private router: Router) {}

  ngOnInit(): void {
  }

  get name(): string {
    return this.app.state.user == null
      ? ""
      : this.app.state.user.name.includes(" ")
      ? this.app.state.user.name.split(" ")[0]
      : this.app.state.user.name;
  }

  goToEditUser() {
    if (this.app.state.user.isAdmin) {
      this.app.editUserBuilder(this.app.state.user);
      this.router.navigate(["/", "admin", "accounts", "admin-form"]);
    }
  }

  edit() {}
}
